import React from "react";

const Button = ({
  children,
  id,
  type = "button",
  onClick,
  width = "100%",
  height = "44px",
  className,
  variant,
  disabled = false,
  font = "font-semibold",
  outline = false,
  value="",
  title="",
  ...rest
}) => {
  
  return (
    <button
      type={type}
      id={id}
      className={`button ${variant} ${disabled ? "disabled cursor-not-allowed disabled" : "cursor-pointer"} ${width ? `w-[${width}]` : "w-full"} ${height ? `h-[${height}]` : "h-[44px]"} ${font || "font-bold"} ${className} ${outline ? "outline" : ""} line-height-[1] inline-block`}
      onClick={onClick}
      disabled={disabled}
      value={value}
      title={title}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
